<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 公司管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>财务-资金账户</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >  
                 <span class="label-span">
                    <label class="label">账户名称</label>
                     <el-input v-model.trim="query.account" placeholder="账户名称" class="handle-input mr10"></el-input>
                 </span>
                 <span class="label-span">
                     <label class="label">账户类型</label>
                     <el-select v-model="query.c" style="width:150px;"  placeholder="账户类型" clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />
                        <el-option value="1" label="公户"  />
                        <el-option value="2" label="私户"  />
                        <el-option value="3" label="第三方"  />
                    </el-select>
                     </span>
                <el-button type="success" icon="el-icon-search"    @click="handleSearch">搜索</el-button>
                <el-button type="warning" icon="el-icon-refresh"    @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd"   @click="addBind" >新增账户</el-button>

          </el-card>
          <el-card shadow="hover"  class="containCard" >  
            <el-table :data="tableData" size="medium"  ref="multipleTable" header-cell-class-name="table-header"   >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="id" width="50" align="left" label="ID"></el-table-column>
                <el-table-column prop="companyName" min-width="120" align="left" label="公司名称"></el-table-column>
                <el-table-column prop="companyCode" min-width="120" align="left" label="公司税号"></el-table-column>
                <el-table-column prop="companyAddress" min-width="230" align="left" label="公司地址"></el-table-column>
                <el-table-column prop="companyTel" width="80" align="left" label="公司电话"></el-table-column>
                <el-table-column prop="bankName" min-width="180" align="left" label="开户银行"></el-table-column>
                <el-table-column prop="bankCardNum" min-width="100" align="left" label="银行卡号"></el-table-column>
                <el-table-column prop="loginName" min-width="80" align="left" label="电子签章">
                    <template slot-scope="scope">
                        <img :src='scope.row.stamp' style='width:50px;' />
                    </template>
                </el-table-column>
                <el-table-column prop="status" min-width="90" align="center" label="账户状态">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.status=='1'?'启用':'停用'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip> 
                    </template> 
                </el-table-column>  
                <el-table-column prop="createTime" width="160" align="left"  label="创建时间"> </el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column> 
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  prev, pager, next" 
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange" 
                ></el-pagination>
            </div>
        </el-card>
        
     
        <!-- 新建代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增账户" :modal-append-to-body='false' :visible.sync="addPlusVisible"   width="620px">
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item required label="公司名称" >
                    <el-input  v-model.trim="form1.companyName"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item required label="公司税号" >
                    <el-input  v-model.trim="form1.companyCode"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item required label="公司地址" >
                    <el-input  v-model.trim="form1.companyAddress"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item required label="公司电话" >
                    <el-input  v-model.trim="form1.companyTel"  placeholder=""></el-input>
                </el-form-item>
                <el-form-item required label="开户银行" >
                    <el-input  v-model.trim="form1.bankName"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item required label="银行卡号" >
                    <el-input  v-model.trim="form1.bankCardNum"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item label="公司签章" >
                    <div>
                        <img :src="form1.stamp" style="width: 100px;height: 100px;border:1px solid #ddd">
                        <div style="position: relative;width: 100px;height: 100px; margin-top:-110px;margin-left:-100px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;">
                            <input type="file" name="image" accept="image/*" @change="chageImage1" style="position: absolute; width: 100px; height: 100px; cursor: pointer;left:100px" />
                        </div>
                    </div>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>
  

     
        <!-- 编辑代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑账户" :modal-append-to-body='false' :visible.sync="editPlusVisible"  width="620px">
            <el-form ref="form" :model="form3" label-width="90px">
                <el-input style='display:none' v-model.trim="form3.id"  placeholder="必填"></el-input>
                <el-form-item required label="公司名称" >
                    <el-input  v-model.trim="form3.companyName"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item required label="公司税号" >
                    <el-input  v-model.trim="form3.companyCode"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item required label="公司地址" >
                    <el-input  v-model.trim="form3.companyAddress"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item required label="公司电话" >
                    <el-input  v-model.trim="form3.companyTel"  placeholder=""></el-input>
                </el-form-item>
                <el-form-item required label="开户银行" >
                    <el-input  v-model.trim="form3.bankName"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item required label="银行卡号" >
                    <el-input  v-model.trim="form3.bankCardNum"  placeholder="必填"></el-input>
                </el-form-item>
                <el-form-item label="公司签章" >
                    <div>
                        <img :src="form3.stamp" style="width: 100px;height: 100px;border:1px solid #ddd">
                        <div style="position: relative;width: 100px;height: 100px; margin-top:-110px;margin-left:-100px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;">
                            <input type="file" name="image" accept="image/*" @change="chageImage2" style="position: absolute; width: 100px; height: 100px; cursor: pointer;left:100px" />
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="editPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
         

    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus} from '../../api/ersAccount';  
export default {

    data() {
        return {  
            Timeout:'',
            mid:'', 
            secret:'',
            stationId:'', 
            loginName:'',
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                payType:'2',
                useType:'1', 
            },
            form2: {   },
            form3: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () {
        //查询列表
        this.getData();  
        //this.getSelect();
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'account', '');    
            this.$set(this.query, 'accountType');    
        }, 
     
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        },

        //获取下拉框数据
        getSelect(){  
            this.select.stationId = this.stationId; 
            this.select.mid = this.mid;
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        }, 
        getSummaries(param){
            const { columns, data } = param;
            const sums = [];
            this.theight = '540px'; 
            columns.forEach((column, index) => {
            if (index == 0) {//只找第一列放合计
                sums[index] = '统计';
                return;
            }  
            if(index == 2 || index == 5 || index == 6 || index == 7 || index == 8){ 
                return '';
            }
            const values = data.map(item => Number(item[column.property]));//把对应一列中的之全部取出，放到一个数组中
            if (!values.every(value => isNaN(value))) {//如果el-table-column中没有prop属性，这里的column.property是undefined，所以判断一下values数组是否为空
                sums[index] = values.reduce((prev, curr) => { 
                const value = Number(curr);//将values中的每个值转换为number类型
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
                }, 0);  
                
                if(index == 3 || index == 4){ 
                    sums[index] = "￥"+parseFloat(sums[index]).toFixed(2);  
                }
            } else {
                sums[index] = ''
            }
            });
            window.setTimeout(() => { 
                this.theight = this.theight2; 
            }, 500) ;
            return sums; 
        },

        //主图修改
        chageImage1(e){
            const file = e.target.files[0];
            if (!file.type.includes('image/')) {
                this.$message.error("只能上传图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {
                this.form1.stamp = event.target.result;
                this.$set(this.form1, 'stamp',event.target.result);
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);
        },
        //主图修改
        chageImage2(e){
            const file = e.target.files[0];
            if (!file.type.includes('image/')) {
                this.$message.error("只能上传图片");
                return;
            }
            if (!file.type.includes('/png') && !file.type.includes('/jpg') && !file.type.includes('/jpeg') ) {
                this.$message.error("只能上传png、jpg、jpeg格式的图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {
                this.form3.stamp = event.target.result;
                this.$set(this.form3, 'stamp',event.target.result);
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);
        },

        //查询
        getData(){
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        //渠道字典表
        channelDir(){
            this.dirVisible=true;
            fetchDataDir(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData2 = res.data;   
                }else{
                    this.$message("暂无数据");
                } 
                
            });

        },
        //选择不同渠道类型显示不同弹框
        addChange(){  
            if(this.form1.channelType==1){
                this.addVisible=false;
                this.addPlusVisible=true;
            }
            if(this.form1.channelType==0){
                this.addVisible=true;
                this.addPlusVisible=false
            }
        }, 

        // 新增渠道
        addBind() {
            this.addPlusVisible = true; 
        },
        //保存新增
        saveForm() {
            if( !this.form1.companyName ){
                this.$message.error("请填写公司名称");
                return;
            }
            if( !this.form1.companyCode ){
                this.$message.error("请填写公司税号");
                return;
            } 
            if( !this.form1.companyAddress ){
                this.$message.error("请填写公司地址");
                return;
            }
            if( !this.form1.companyTel ){
                this.$message.error("请填写公司电话");
                return;
            }
            if( !this.form1.bankName ){
                this.$message.error("请填写开户银行");
                return;
            }
            if( !this.form1.bankCardNum ){
                this.$message.error("请填写银行卡号");
                return;
            }
            this.addPlusVisible = false;
            saveForm(this.form1).then(res => {
                if(res.code=='200'){
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.addPlusVisible = true;
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {  
            this.editPlusVisible = true;
            this.form3 = row;   
        },

         
        // 保存更改
        saveEdit() {
            if( !this.form3.companyName ){
                this.$message.error("请填写公司名称");
                return;
            }
            if( !this.form3.companyCode ){
                this.$message.error("请填写公司税号");
                return;
            }
            if( !this.form3.companyAddress ){
                this.$message.error("请填写公司地址");
                return;
            }
            if( !this.form3.companyTel ){
                this.$message.error("请填写公司电话");
                return;
            }
            if( !this.form3.bankName ){
                this.$message.error("请填写开户银行");
                return;
            }
            if( !this.form3.bankCardNum ){
                this.$message.error("请填写银行卡号");
                return;
            }
            this.editPlusVisible = false;
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.editPlusVisible = true;
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) { 
            let data = {};
            data = row;
            data.stationId = this.stationId; 
            data.mid = this.mid; 
            var tips="启用";
            if(row.status==0){
                tips="停用";
            } 
            changeStatus(data).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(tips+'成功'); 
                    this.getData();
                }else{ 
                    this.$message.error(tips+'失败');
                } 
            }); 
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {
            this.form = row; 
            this.form.delFag = '1'
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('去顶要删除该商户吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
